import { render, staticRenderFns } from "./ClienteContainer.vue?vue&type=template&id=7983fbe5&scoped=true"
import script from "./ClienteContainer.vue?vue&type=script&lang=js"
export * from "./ClienteContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7983fbe5",
  null
  
)

export default component.exports